var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('results-wrapper',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"MHP Overview"}},[_c('div',{staticClass:"bat-result-scenario"},_vm._l((Object.entries(_vm.results)),function(ref,index){
var title = ref[0];
var infos = ref[1];
return _c('result-card',{key:index,staticClass:"card",attrs:{"title":title,"infos":infos}})}),1),_c('div',{staticClass:"powerhouse-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("MHP Information")]),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},_vm._l((_vm.tableColumns),function(ref){
var prop = ref.prop;
var label = ref.label;
var width = ref.width;
var formatter = ref.formatter;
return _c('el-table-column',{key:prop,attrs:{"prop":prop,"formatter":formatter,"label":label,"width":width}})}),1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }